import { BusinessCostsModels } from './businessCosts.models';

export class PraImpactAnalysesModels {
  businessCosts?: BusinessCostsModels[];
  firstYearBudgetCosts: string;
  firstYearSmallBusinessCosts: string;
  fiveYearBudgetCosts: string;
  fiveYearSmallBusinessCosts: string;
  largeBusinessCount: number;
  mediumBusinessCount: number;
  microBusinessCount: number;
  regImpactAnalysisId: string;
  regPlanItemId: string;
  smallBusinessCount: 0;

  constructor(itemA: any) {
    this.firstYearBudgetCosts = itemA.firstYearBudgetCosts;
    this.firstYearSmallBusinessCosts = itemA.firstYearSmallBusinessCosts;
    this.firstYearSmallBusinessCosts = itemA.firstYearSmallBusinessCosts;
    this.fiveYearBudgetCosts = itemA.fiveYearBudgetCosts;
    this.fiveYearSmallBusinessCosts = itemA.fiveYearSmallBusinessCosts;
    this.largeBusinessCount = itemA.largeBusinessCount;
    this.mediumBusinessCount = itemA.mediumBusinessCount;
    this.microBusinessCount = itemA.microBusinessCount;
    this.regImpactAnalysisId = itemA.regImpactAnalysisId;
    this.regPlanItemId = itemA.regPlanItemId;
    this.smallBusinessCount = itemA.smallBusinessCount;
    this.businessCosts = itemA.businessCosts?.map(
      (business: any) => new BusinessCostsModels(business),
    );
  }
}
